import { useEffect, useState } from "react"
import { Box, Button, MenuItem } from "@mui/material"
import { useForm, Controller } from "react-hook-form"
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider"
import "dayjs/locale/en-gb"
// import {OreveButton} from "components/OreveButton.tsx";
import { useSessionsContext } from "layouts/sessions/context/sessions-context"
import { StyledTextField } from "components/inputs/StyledTextField"
import { DateRangePopup } from "layouts/sessions/filter/DateRangePopup"
import { FilterStatus } from "layouts/sessions/utils/const.ts"
import { threeMonthsBeforeStartOfMonth } from "layouts/sessions/utils/functions.ts"

export const FilterSessions = () => {
    const { onFilterSubmit, defaultFilterValues } = useSessionsContext()

    const { control, handleSubmit, setValue } = useForm({
        defaultValues: defaultFilterValues,
        mode: "onChange",
    })

    const [dateRange, setDateRange] = useState("")
    const [openDatePopup, setOpenDatePopup] = useState(false)
    const [fromDate, setFromDate] = useState<null | number>(threeMonthsBeforeStartOfMonth(Date.now()))
    const [untilDate, setUntilDate] = useState<null | number>(null)

    const labelDateRangeFilter = "Période de dates de recharge"

    const statusOptions = [
        { value: FilterStatus.All, label: "Tous", dataCy: "session__status--all" },
        { value: FilterStatus.InProgress, label: "En charge", dataCy: "session__status--inprogress" },
        { value: FilterStatus.Failed, label: "Échouée", dataCy: "session__status--failed" },
        { value: FilterStatus.Finished, label: "Terminée", dataCy: "session__status--finished" },
    ]

    useEffect(() => {
        let dateRange = ""
        if (fromDate && untilDate) {
            const fromDateObject = new Date(fromDate)
            const untilDateObject = new Date(untilDate)
            dateRange = `Du ${fromDateObject.toLocaleDateString("fr-FR")} au ${untilDateObject.toLocaleDateString("fr-FR")}`
        } else if (fromDate) {
            const date = new Date(fromDate)
            dateRange = "Depuis le " + date.toLocaleDateString("fr-FR")
        } else if (untilDate) {
            const date = new Date(untilDate)
            dateRange = "Jusqu'au " + date.toLocaleDateString("fr-FR")
        }
        setDateRange(dateRange)
    }, [untilDate, fromDate])

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
            <form onSubmit={handleSubmit(onFilterSubmit)}>
                <DateRangePopup
                    open={openDatePopup}
                    title={labelDateRangeFilter}
                    control={control}
                    handleClose={() => setOpenDatePopup(false)}
                    setFromDate={setFromDate}
                    setUntilDate={setUntilDate}
                    fromDate={fromDate}
                    untilDate={untilDate}
                    setValue={setValue}
                />
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        gap: "1rem",
                        width: "100%",
                        height: "56px",
                    }}
                >
                    <Controller
                        name="status"
                        control={control}
                        render={({ field }) => {
                            return (
                                <StyledTextField
                                    id="sessions-page-status"
                                    select
                                    label="Statut"
                                    {...field}
                                    data-cy="header-nav__session--status"
                                >
                                    {statusOptions.map((status) => (
                                        <MenuItem
                                            key={status.value}
                                            value={status.value}
                                            data-cy={status.dataCy}
                                        >
                                            {status.label}
                                        </MenuItem>
                                    ))}
                                </StyledTextField>
                            )
                        }}
                    />
                    <StyledTextField
                        data-testid="session-date-filter"
                        id="session-page-date"
                        data-cy="header-nav__session-date"
                        label={labelDateRangeFilter}
                        sx={{ width: "150%" }}
                        slotProps={{
                            input: {
                                readOnly: true,
                                disableUnderline: true,
                            },
                        }}

                        value={dateRange}
                        onClick={() => {
                            setOpenDatePopup(true)
                        }}
                        focused={false}
                    />
                    <Controller
                        name="rfid_number"
                        control={control}
                        render={({ field }) => (
                            <StyledTextField
                                id="sessions-page-rfid"
                                label="Numéro de carte"
                                data-cy="header-nav__session--rfid-number"
                                {...field}
                            />
                        )}
                    />
                    <Controller
                        name="card_holder"
                        control={control}
                        render={({ field }) => (
                            <StyledTextField
                                id="session-page-driver"
                                label="Conducteur/Véhicule"
                                data-cy="header-nav__session--card-holder"
                                {...field}
                            />
                        )}
                    />

                    <Button
                        data-testid="submit-filter-sessions"
                        data-cy="session—submit-filter"
                        type="submit"
                        variant="contained"
                        color="primary"
                        sx={{
                            minWidth: "56px",
                            height: "56px",
                            aspectRatio: "1/1",
                            borderRadius: "10px",
                            "&:hover, &:focus": {
                                backgroundColor: "primary.hover",
                            },
                        }}
                    >
                        <SearchOutlinedIcon
                            sx={{
                                color: "white",
                                fontSize: "2rem",
                            }}
                        />
                    </Button>
                </Box>
            </form>
        </LocalizationProvider>
    )
}
